<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-message-circle-more-icon lucide-message-circle-more"
    >
        <path
            d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
        />
        <path d="M8 12h.01" />
        <path d="M12 12h.01" />
        <path d="M16 12h.01" />
    </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    size: {
        type: [Number, String],
        default: 18,
    },
    width: {
        type: [Number, String],
        default: null,
    },
    height: {
        type: [Number, String],
        default: null,
    },
});

const resolvedSize = computed(() => props.width ?? props.height ?? props.size);
</script>
